import React from 'react';
import PropTypes from 'prop-types';
import { FieldLabel } from '@puckeditor/core';

const RadioField = ({
  id,
  name,
  hint,
  label,
  value,
  onChange,
  options,
  groupStyle,
  fitContent,
  readOnly,
}) => (
  <div className="puck-common-radio-field">
    <FieldLabel label={label}>
      {hint && (
        <div className="puck-common-field-hint">
          {hint}
        </div>
      )}
      <div
        className={`puck-common-radio-group${fitContent ? ' puck-common-radio-group-fit-content' : ''}`}
        id={id}
        style={groupStyle}
      >
        {options.map((option) => (
          <label
            key={String(option.value)}
            className="puck-common-radio-option"
          >
            <input
              type="radio"
              className="puck-common-radio-input"
              name={name || id}
              checked={value === option.value}
              onChange={() => {
                if (!readOnly) {
                  onChange(option.value);
                }
              }}
              disabled={readOnly}
            />
            <span className="puck-common-radio-inner">{option.label}</span>
          </label>
        ))}
      </div>
    </FieldLabel>
  </div>
);

RadioField.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  hint: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  groupStyle: PropTypes.object,
  fitContent: PropTypes.bool,
  readOnly: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.any,
  })).isRequired,
};

RadioField.defaultProps = {
  id: '',
  name: '',
  hint: '',
  label: '',
  value: null,
  groupStyle: null,
  fitContent: false,
  readOnly: false,
};

export default RadioField;
